import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=71c0836e"
import script from "./UserNav.vue?vue&type=script&lang=ts"
export * from "./UserNav.vue?vue&type=script&lang=ts"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=71c0836e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
